import React from 'react';

function GoogleGIcon() {
    return (
        <svg
            className="google-sign-in-icon"
            aria-hidden="true"
            focusable="false"
            viewBox="0 0 18 18"
        >
            <path
                fill="#4285F4"
                d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84c-.21 1.12-.84 2.07-1.79 2.71v2.26h2.9c1.7-1.57 2.69-3.88 2.69-6.61z"
            />
            <path
                fill="#34A853"
                d="M9 18c2.43 0 4.47-.81 5.96-2.19l-2.9-2.26c-.81.54-1.84.86-3.06.86-2.35 0-4.34-1.59-5.05-3.72H.96v2.33C2.44 15.95 5.48 18 9 18z"
            />
            <path
                fill="#FBBC05"
                d="M3.95 10.69c-.18-.54-.28-1.11-.28-1.69s.1-1.15.28-1.69V4.98H.96C.35 6.19 0 7.56 0 9s.35 2.81.96 4.02l2.99-2.33z"
            />
            <path
                fill="#EA4335"
                d="M9 3.58c1.32 0 2.51.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0 5.48 0 2.44 2.05.96 4.98l2.99 2.33C4.66 5.17 6.65 3.58 9 3.58z"
            />
        </svg>
    );
}

function XIcon() {
    return (
        <svg
            className="x-sign-in-icon"
            aria-hidden="true"
            focusable="false"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                d="M18.24 2.25h3.31l-7.23 8.26 8.5 11.24h-6.65l-5.21-6.81-5.96 6.81H1.69l7.73-8.84L1.27 2.25h6.82l4.71 6.23 5.44-6.23Zm-1.16 17.52h1.83L7.09 4.13H5.12l11.96 15.64Z"
            />
        </svg>
    );
}

function SocialAuthButtons({
    disabled = false,
    onGoogle,
    onX,
    googleLabel = 'Sign in with Google',
    xLabel = 'Sign in with X'
}) {
    return (
        <div className="social-sign-in-options">
            <button
                type="button"
                className="social-sign-in-btn google-sign-in-btn"
                disabled={disabled}
                onClick={onGoogle}
            >
                <GoogleGIcon />
                <span>{googleLabel}</span>
            </button>

            <button
                type="button"
                className="social-sign-in-btn x-sign-in-btn"
                disabled={disabled}
                onClick={onX}
            >
                <XIcon />
                <span>{xLabel}</span>
            </button>
        </div>
    );
}

export { GoogleGIcon, SocialAuthButtons, XIcon };
